import { createFileRoute } from '@tanstack/react-router';
import { WinnersStep } from '../features/rsvp/steps/WinnersStep';

export const Route = createFileRoute('/')({
  component: WinnersPage,
});

function WinnersPage() {
  return <WinnersStep />;
}
